/**** 02.04.26 dla eigener Style für Javascripts added to layout/theme.liquid ****/



/* ============================================
   1. LOGO-REPLACE
   Ersetzt das Wort "Click" durch die Click-Grafik
   in h1, h2 und b-Elementen
   UNVERÄNDERT
   ============================================ */
(function() {
  const logoWhite = "https://cdn.shopify.com/s/files/1/0954/9719/1754/files/Click_Logo_White.png?v=1775823937";
  const logoBlack = "https://cdn.shopify.com/s/files/1/0954/9719/1754/files/Click_Logo_Black.png?v=1775823936";

  // ↓↓↓ HIER ANPASSEN ↓↓↓
  const configH2 = { x: -15, y: -5,  size: 2.4 };  // h2: weisses Logo
  const configH1 = { x: 0,  y: -10, size: 3   };  // h1: schwarzes Logo
  const configB  = { x: 0,  y: -2,  size: 2.2  };  // b:  schwarzes Logo
  // ↑↑↑ HIER ANPASSEN ↑↑↑

  function replaceClick(el, logoUrl, cfg) {
    if (/click/i.test(el.textContent)) {
      const fontSize = parseFloat(window.getComputedStyle(el).fontSize);
      el.innerHTML = el.innerHTML.replace(/click/gi,
        `<img src="${logoUrl}" alt="Click" style="
          height:${fontSize * cfg.size}px;
          width:auto;
          vertical-align:middle;
          display:inline-block;
          position:relative;
          left:${cfg.x}px;
          top:${cfg.y}px;
        ">`
      );
    }
  }

  // document.querySelectorAll('h2') auskommentiert –
  // verhindert dass alle h2 ersetzt werden
  const heroH2 = document.querySelector('.video--heading h2[data-item="section-heading"]');
  if (heroH2) replaceClick(heroH2, logoWhite, configH2);

  document.querySelectorAll('h1.template-page--heading').forEach(el => replaceClick(el, logoBlack, configH1));
  document.querySelectorAll('b').forEach(el => replaceClick(el, logoBlack, configB));
})();


/* ============================================
   2. BUBBLE ANIMATION
   Erstellt 200 animierte Partikel im #bubbleContainer
   UNVERÄNDERT
   ============================================ */
(function() {
  const container = document.getElementById('bubbleContainer');
  if (!container) return;

  const particleNum = 200;
  const particleBaseSize = 8;

  for (let i = 0; i < particleNum; i++) {
    const circleSize      = Math.ceil(Math.random() * particleBaseSize);
    const startPositionY  = Math.ceil(Math.random() * 10) + 100;
    const moveDuration    = 28000 + Math.ceil(Math.random() * 9000);
    const animDelay       = Math.ceil(Math.random() * 37000);
    const circleDelay     = Math.ceil(Math.random() * 4000);
    const fromX           = Math.ceil(Math.random() * 100);
    const toX             = Math.ceil(Math.random() * 100);
    const toY             = startPositionY + Math.ceil(Math.random() * 30);

    const framesName = `bubble-move-${i}`;
    const styleSheet = document.styleSheets[0];
    try {
      styleSheet.insertRule(`
        @keyframes ${framesName} {
          from { transform: translate3d(${fromX}vw, ${startPositionY}vh, 0); }
          to   { transform: translate3d(${toX}vw, -${toY}vh, 0); }
        }
      `, styleSheet.cssRules.length);
    } catch(e) {}

    const wrapper = document.createElement('div');
    wrapper.className = 'bubble-circle-container';
    wrapper.style.width             = circleSize + 'px';
    wrapper.style.height            = circleSize + 'px';
    wrapper.style.animationName     = framesName;
    wrapper.style.animationDuration = moveDuration + 'ms';
    wrapper.style.animationDelay    = animDelay + 'ms';

    const circle = document.createElement('div');
    circle.className = 'bubble-circle';
    circle.style.width        = '100%';
    circle.style.height       = '100%';
    circle.style.animationDelay = circleDelay + 'ms';

    wrapper.appendChild(circle);
    container.appendChild(wrapper);
  }
})();


/* ============================================
   3. MODAL-STEUERUNG
   Register as Reseller – Overlay öffnen/schließen
   UNVERÄNDERT
   ============================================ */
(function () {

  function openModal(id) {
    var target = document.getElementById(id);
    if (target) {
      target.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeModal() {
    var embed = document.querySelector('shopify-forms-embed');
    if (embed) {
      embed.classList.add('slide-out-active');
      setTimeout(function () {
        embed.classList.remove('slide-out-active');
        document.querySelectorAll('.modal-overlay.is-open').forEach(function (m) {
          m.classList.remove('is-open');
        });
        document.body.style.overflow = '';
        history.back();
      }, 420);
    } else {
      document.querySelectorAll('.modal-overlay.is-open').forEach(function (m) {
        m.classList.remove('is-open');
      });
      document.body.style.overflow = '';
      history.back();
    }
  }

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      document.querySelectorAll('.modal-overlay.is-open').forEach(function (m) {
        m.classList.remove('is-open');
      });
      document.body.style.overflow = '';
    }
  });

  document.querySelectorAll('.modal__close').forEach(function (btn) {
    btn.addEventListener('click', closeModal);
  });

  document.querySelectorAll('.modal-overlay').forEach(function (overlay) {
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeModal();
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  document.addEventListener('DOMContentLoaded', function () {
    var modalOpened = false;

    var modalObs = new MutationObserver(function () {
      var embed = document.querySelector('shopify-forms-embed');
      if (embed && !modalOpened) {
        modalOpened = true;
        modalObs.disconnect();
        openModal('reseller-modal');
      }
    });
    modalObs.observe(document.body, { childList: true, subtree: true });

    setTimeout(function () {
      if (!modalOpened) {
        modalOpened = true;
        modalObs.disconnect();
        openModal('reseller-modal');
      }
    }, 3000);
  });

})();


/* ============================================
   4. SHADOW DOM STYLES
   v14 – Inline-Form auf /pages/qpp-reseller-registration ausgeschlossen
   ============================================ */
(function() {

  // ── Nicht auf der Inline-Form-Seite ausführen ──
  if (window.location.pathname === '/pages/qpp-reseller-registration') return;

  if (window.location.pathname.includes('qpp-reseller-registration')) {
  document.body.classList.add('qpp-inline-form-page');
  return;
}

  function tryInject() {
    const formEmbed = document.querySelector('shopify-forms-embed');
    if (!formEmbed) return;
    const shadow = formEmbed.shadowRoot;
    if (!shadow) return;

    const old = shadow.querySelector('#neumorphic-style');
    if (old) old.remove();

    const s = document.createElement('style');
    s.id = 'neumorphic-style';
    s.textContent = `

      @keyframes slideInRight {
        from { opacity: 0; transform: translateX(120px); }
        to   { opacity: 1; transform: translateX(0); }
      }

      @keyframes slideOutRight {
        from { opacity: 1; transform: translateX(0); }
        to   { opacity: 0; transform: translateX(120px); }
      }

      :host, ._teaserContainer_trejf_5, ._formFieldset_cit2d_82, ._formHeader_cit2d_24,
      ._consentCheckboxContainer_cit2d_49, ._formDisclaimer_cit2d_38,
      ._checkboxFieldSet_1hja3_3, ._verticalLayout_1hja3_8,
      ._nonMultineFieldLine_exnrn_11, ._nonMultineFieldLine_exnrn_11 > div,
      ._selectContainer_12thd_6, ._checkboxField_1hja3_3,
      ._checkboxField_11ej1_1, legend {
        background: transparent !important;
      }

      ._teaserContainer_trejf_5 [aria-label="Close"],
      ._teaserContainer_trejf_5 button[class*="_closeButton_"],
      ._teaserContainer_trejf_5 svg:last-child {
        display: none !important;
      }

      ._formContainer_1q1d2_30 {
        background-color: transparent !important;
      }

      [class*="_teaserContainer_"] {
        transition: transform 0.25s ease, box-shadow 0.25s ease, background-color 0.25s ease;
        cursor: pointer;
      }
      [class*="_teaserContainer_"]:hover {
        transform: translateX(-4px);
        box-shadow: -4px 4px 16px rgba(0,0,0,0.18);
        background-color: #c0a060;
      }

      ._formCloseButton_1684x_4 {
        font-size: 0.2em !important;
      }

      ._gridItem_1q1d2_172 {
        background-color: transparent !important;
        background-image: url('https://cdn.shopify.com/s/files/1/0954/9719/1754/files/become-part-of-us-register-now-realism_2048x2048.png?v=1775143885');
      }

      [data-ref="form-container-ref"],
      #form-container-ref,
      .form-container-ref {
        animation: slideInRight 1.678s cubic-bezier(0.22, 1, 0.36, 1) forwards !important;
        overflow: hidden;
      }

      shopify-forms-embed.slide-out-active [data-ref="form-container-ref"],
      shopify-forms-embed.slide-out-active #form-container-ref,
      shopify-forms-embed.slide-out-active .form-container-ref {
        animation: slideOutRight 0.4s cubic-bezier(0.22, 1, 0.36, 1) forwards !important;
      }

      ._formHeader_cit2d_24 {
        text-align: center !important;
        margin-bottom: 32px !important;
      }
      ._textHeading_2aowh_35 {
        color: #3d4468 !important;
        font-size: 1.8rem !important;
        font-weight: 500 !important;
        padding: 20px;
      }
      ._textBody_2aowh_10, ._textBody_2aowh_10 p {
        color: #9499b7 !important;
        background: transparent !important;
      }

      ._formFieldContainer_1mxsl_5 {
        margin-bottom: 18px !important;
        position: relative !important;
        background: #e0e5ec !important;
        border-radius: 12px !important;
        box-shadow: inset 6px 6px 12px #b8bec9, inset -6px -6px 12px #ffffff !important;
        border: none !important;
      }
      ._formFieldContainer_1mxsl_5:focus-within {
        box-shadow: inset 3px 3px 6px #b8bec9, inset -3px -3px 6px #ffffff, 0 0 0 2px #7b8cde !important;
      }

      ._formInputField_nag3b_7 {
        background: transparent !important;
        border: none !important;
        outline: none !important;
        box-shadow: none !important;
        padding: 18px 20px !important;
        color: #3d4468 !important;
        font-size: 15px !important;
        width: 100% !important;
        border-radius: 12px !important;
      }
      ._formInputField_nag3b_7:focus {
        outline: none !important;
        box-shadow: none !important;
        border: none !important;
      }

      ._formInputFieldLabel_1mxsl_38 {
        position: absolute !important;
        left: 20px !important;
        top: 50% !important;
        transform: translateY(-50%) !important;
        color: #9499b7 !important;
        font-size: 15px !important;
        transition: all 0.25s ease !important;
        pointer-events: none !important;
        background: transparent !important;
      }
      ._inputFilled_1mxsl_74 {
        top: 6px !important;
        font-size: 11px !important;
        color: #6c7293 !important;
        transform: translateY(0) !important;
      }

      ._selectToggle_12thd_25 {
        background: #e0e5ec !important;
        border: none !important;
        border-radius: 12px !important;
        padding: 16px 20px !important;
        box-shadow: inset 6px 6px 12px #b8bec9, inset -6px -6px 12px #ffffff !important;
        color: #3d4468 !important;
        width: 100% !important;
        display: flex !important;
        justify-content: space-between !important;
        align-items: center !important;
        cursor: pointer !important;
        height: 58px !important;
      }

      .phone-country-selector {
        display: flex !important;
        align-items: center !important;
        height: 100% !important;
        padding: 0 8px !important;
        border-right: 1px solid #b8bec9 !important;
        flex-shrink: 0 !important;
      }
      .phone-country-selector ._selectToggle_12thd_25 {
        background: transparent !important;
        box-shadow: none !important;
        border-radius: 0 !important;
        padding: 0 8px !important;
        height: 100% !important;
        gap: 6px !important;
        margin: 0 !important;
      }

      ._flagIcon_py6yc_5 {
        width: 24px !important;
        height: 18px !important;
        border-radius: 3px !important;
        object-fit: cover !important;
        display: block !important;
      }

      ._nonMultineFieldLine_exnrn_11 {
        display: flex !important;
        gap: 12px !important;
      }
      ._nonMultineFieldLine_exnrn_11 > div { flex: 1 !important; }

      legend, legend._textBody_2aowh_10 {
        color: #6c7293 !important;
        font-size: 12px !important;
        font-weight: 700 !important;
        text-transform: uppercase !important;
        letter-spacing: 1px !important;
        margin: 16px 0 12px !important;
      }

      ._checkboxField_1hja3_3, ._checkboxField_11ej1_1 {
        display: flex !important;
        align-items: center !important;
        gap: 12px !important;
        cursor: pointer !important;
        color: #6c7293 !important;
        font-size: 14px !important;
        margin-bottom: 18px !important;
      }
      ._checkboxInput_1hja3_38, ._checkboxInput_11ej1_7 {
        appearance: none !important;
        -webkit-appearance: none !important;
        width: 22px !important;
        height: 22px !important;
        min-width: 22px !important;
        border-radius: 6px !important;
        background: #e0e5ec !important;
        box-shadow: 3px 3px 8px #b8bec9, -3px -3px 8px #ffffff !important;
        border: none !important;
        cursor: pointer !important;
        position: relative !important;
        transition: all 0.3s ease !important;
      }
      ._checkboxInput_1hja3_38:checked, ._checkboxInput_11ej1_7:checked {
        background: #00c896 !important;
        box-shadow: inset 2px 2px 5px rgba(0,0,0,0.2) !important;
      }
      ._checkboxInput_1hja3_38:checked::after, ._checkboxInput_11ej1_7:checked::after {
        content: '✓' !important;
        position: absolute !important;
        top: 50% !important;
        left: 50% !important;
        transform: translate(-50%, -50%) !important;
        color: white !important;
        font-size: 13px !important;
        font-weight: 700 !important;
      }

      ._formSubmitButton_cit2d_96 {
        width: 80% !important;
        background: #e0e5ec !important;
        border: none !important;
        border-radius: 12px !important;
        padding: 18px 32px !important;
        color: #3d4468 !important;
        font-size: 16px !important;
        font-weight: 600 !important;
        cursor: pointer !important;
        box-shadow: 8px 8px 20px #bec3cf, -8px -8px 20px #ffffff !important;
        transition: all 0.3s ease !important;
        margin-top: 8px !important;
        margin-bottom: 16px !important;
      }
      ._formSubmitButton_cit2d_96:hover {
        transform: translateY(-2px) !important;
        box-shadow: 12px 12px 28px #bec3cf, -12px -12px 28px #ffffff !important;
      }
      ._formSubmitButton_cit2d_96:active {
        transform: translateY(0) !important;
        box-shadow: inset 4px 4px 10px #bec3cf, inset -4px -4px 10px #ffffff !important;
      }

      ._formDisclaimer_cit2d_38 p {
        color: #9499b7 !important;
        font-size: 12px !important;
        text-align: center !important;
      }

      ._formFieldContainer_1mxsl_5:has(input[aria-invalid="true"]) {
        box-shadow: inset 6px 6px 12px #ffb8c4, inset -6px -6px 12px #ffffff, 0 0 0 2px #ff3b5c !important;
      }

      @media (max-width: 480px) {
        ._nonMultineFieldLine_exnrn_11 { flex-direction: column !important; gap: 0 !important; }
      }
    `;
    shadow.appendChild(s);
    console.log('✅ Styles v14 initiated!');

    var internalClose = shadow.querySelector('._formCloseButton_1684x_4');
    if (internalClose && !internalClose.dataset.listenerAttached) {
      internalClose.dataset.listenerAttached = 'true';
      internalClose.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var embed = document.querySelector('shopify-forms-embed');
        if (embed) {
          embed.classList.add('slide-out-active');
          setTimeout(function () {
            embed.classList.remove('slide-out-active');
            history.back();
          }, 420);
        } else {
          history.back();
        }
      });
    }
  }

  const embedObs = new MutationObserver(() => {
    const el = document.querySelector('shopify-forms-embed');
    if (el) {
      embedObs.disconnect();
      setTimeout(tryInject, 500);
    }
  });
  embedObs.observe(document.body, { childList: true, subtree: true });
  tryInject();

})();


/* ============================================
   5. SCROLL-TO-TOP BUTTON
   UNVERÄNDERT
   ============================================ */
(function () {
  var btn = document.getElementById('qpp-scroll-top');
  if (!btn) return;

  window.addEventListener('scroll', function () {
    btn.style.display = window.scrollY > 300 ? 'flex' : 'none';
  });

  btn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
})();